import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './main.css'
import App from './App.vue'
import axiosPlugin from './services/axiosPlugin'
import toastPlugin from './services/toastPlugin'
import router from './router'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

Sentry.init({
	app,
	dsn: 'https://c2c67855bcbfe0d31fa5a8a55d21e0b5@o4511864328290304.ingest.de.sentry.io/4512022547136592',
	dataCollection: {
		// To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
		// https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
		// userInfo: false,
		// httpBodies: []
	},
	integrations: [
		Sentry.browserTracingIntegration({ router }),
		Sentry.replayIntegration(),
		Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
	],
	// Tracing
	tracesSampleRate: 1.0, // Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: [
		'localhost',
		/^https:\/\/devtest\.api\.euccz\.org\/dev\/public\/rest\/meuc\/domains\/telemedicine\/v2\//,
		/^https:\/\/login-dev\.euc\.cz\/v2\//
	],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
	// Logs
	enableLogs: true
})

app.use(createPinia())
app.use(axiosPlugin)
app.use(toastPlugin)
app.use(router)
app.mount('#app')
